import React, { forwardRef, HTMLAttributes, useMemo } from 'react'
import styles from './ShadowContainer.module.sass'
import clsx from 'clsx'
import { PopoverState } from 'react-tiny-popover'

interface Props extends HTMLAttributes<HTMLDivElement> {
    state?: PopoverState,
    height?: number,
}

export const calculateMaxHeight = (targetRect?: ClientRect, height?: number): number | undefined => {
    if (targetRect) {
        const bottomSpace = Math.min(window.innerHeight - targetRect.bottom - 8, height ?? 500)
        const topSpace = Math.min(targetRect.top, height ?? 500)
        return bottomSpace < 200 ? topSpace : bottomSpace
    }
}

const ShadowContainer = forwardRef<HTMLDivElement, Props>((
    { className, state, height, ...restProps },
    ref
) => {
    const maxHeight = useMemo(() => calculateMaxHeight(state?.childRect, height), [height, state?.childRect])

    return <div
        {...restProps}
        ref={ref}
        style={{
            ...restProps.style,
            maxHeight,
            minWidth: state?.childRect.width,
        }}
        className={clsx(className, styles.container)}
    />
})

ShadowContainer.displayName = 'ShadowContainer'

export default ShadowContainer